export function DemoPopUp(el) {
    if (!el) {
        return;
    }
    var triggerPaths = [
        '/bli-kund',
        '/bli-kund/',
        '/demo'
    ];
    var config = {
        windowToggled: false,
        classNames: {
            toggled: 'toggled'
        }
    };
    function closePopup() {
        el.classList.remove(config.classNames.toggled);
        config.windowToggled = false;
    }
    ;
    function openPopup() {
        el.classList.add(config.classNames.toggled);
        config.windowToggled = true;
    }
    ;
    el.addEventListener('click', function (event) {
        if (config.windowToggled && event.target === el) {
            closePopup();
        }
    });
    var closeBtn = el.querySelector('#closePopUp');
    if (closeBtn) {
        closeBtn.addEventListener('click', function () { return closePopup(); });
    }
    // Listen for all clicks on site and toggle the demo window if any of the trigger paths are met with the event.
    document.addEventListener('click', function (event) {
        if (triggerPaths.includes(event.target.pathname)) {
            event.preventDefault();
            if (!config.windowToggled) {
                openPopup();
                return;
            }
            closePopup();
        }
    });
    var divsInPopup = Array.from(el.querySelectorAll('div'));
    var messageEl = divsInPopup.filter(function (div) {
        if (div.id && div.id.includes('_message')) {
            return div;
        }
    });
    var observerOptions = {
        attributes: true
    };
    function mutationCallback() {
        var hideThisMessage = document.querySelector('#messageToHide');
        if (hideThisMessage) {
            hideThisMessage.style.display = 'none';
        }
    }
    if (messageEl[0]) {
        var observer = new MutationObserver(mutationCallback);
        observer.observe(messageEl[0], observerOptions);
    }
}
